"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _reactRouterDom = require("react-router-dom");

var _InspirationWrapper = require("../../InspirationWrapper");

var _ViewPostModal = _interopRequireDefault(require("../components/ViewPostModal"));

var _api = require("../../../api");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ViewPostModal = function ViewPostModal(_ref) {
  var inspirationId = _ref.inspirationId,
      onClose = _ref.onClose,
      openReportModal = _ref.openReportModal,
      isVisible = _ref.isVisible,
      history = _ref.history,
      location = _ref.location,
      overrideStatus = _ref.overrideStatus;
  return _react.default.createElement(_commonReact.RequestProvider, {
    requests: {
      getInspiration: (0, _api.getInspirationApi)()
    }
  }, function (_ref2) {
    var getInspiration = _ref2.getInspiration;
    return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref3) {
      var fetchAssets = _ref3.fetchAssets;
      return _react.default.createElement(_InspirationWrapper.InspirationOrgConsumer, null, function (_ref4) {
        var selectedInspirationOrgId = _ref4.selectedInspirationOrgId,
            setSelectedOrgId = _ref4.setSelectedOrgId;
        return _react.default.createElement(_ViewPostModal.default, {
          isVisible: isVisible,
          onClose: onClose,
          inspirationId: inspirationId,
          getInspiration: getInspiration,
          openReportModal: openReportModal,
          fetchAssets: fetchAssets,
          history: history,
          location: location,
          selectedInspirationOrgId: selectedInspirationOrgId,
          setSelectedOrgId: setSelectedOrgId,
          overrideStatus: overrideStatus
        });
      });
    });
  });
};

var _default = (0, _reactRouterDom.withRouter)(ViewPostModal);

exports.default = _default;